import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { DiVim } from "react-icons/di";
import { MdOutline10K, MdOutlineStar } from "react-icons/md";
import {useDispatch} from "react-redux"
import {addToCart} from "../redux/bazarSlice"
import { ToastContainer,toast } from "react-toastify";
const Product = () => {
    const dispatch=useDispatch()
    const [detail, setdetail] = useState({});
    let [baseQty,setBaseQty] =useState(1);
    const Location = useLocation();
    useEffect(() => {
        setdetail(Location.state.item)
    })
    return (<div>
        <div className="max-w-screen-xl mx-auto my-10 flex gap-10">
            <div className="w-2/5 relative">
                <img className=" w-full h-[550px] object-cover" src={detail.image} alt="" />
                <div className="absolute top-4 right-2">
                    {
                        detail.isNew && (
                            <p className="bg-black text-white font-semibold font-titleFont px-6 py-1 ">Sale</p>
                        )
                    }
                </div>
            </div>
            <div className="w-3/5 flex flex-col justify-center items-start gap-6 ml-6">
                <div>
                    <h2 className="text-4xl font-semibold">{detail.title}</h2>

                </div>
            
            <div className="flex gap-2 text-xl items-center ">
                <p className="line-through text-gray-500 mx-3">${detail.oldPrice}</p>
                <p className="font-semibold mx-2">${detail.price}</p>
            </div>
           <div className="flex gap-2 text-base">
            <div className="flex">
            <MdOutlineStar></MdOutlineStar>
            <MdOutlineStar></MdOutlineStar>
            <MdOutlineStar></MdOutlineStar>
            <MdOutlineStar></MdOutlineStar>
            <MdOutlineStar></MdOutlineStar>
            </div>
            <div>
                <p>(1 customer review)</p>
            </div>

            
           </div>
         
           <div className="text-base text-gray-500 mt-3 ">{detail.description}</div>
           <div className="flex gap-6">
           <div className=" w-52 px-4 py-2 flex justify-between border">
           <p className="text-sm">Quatity</p>
           <div className="flex items-center gap-4 text-sm font-semibold">
           <button onClick={()=>setBaseQty(baseQty===1?(baseQty=1):baseQty-1)}className="border  h-5 font-normal text-lg flex items-center justify-center px-2 hover:bg-gray-800 hover:text-white cursor-pointer duration-300 position-fixed">-</button>
           <span>{baseQty}</span>
           <button onClick={()=>setBaseQty(baseQty+1)}className="border h-5 font-normal text-lg flex items-center justify-center px-2 hover:bg-gray-800 hover:text-white cursor-pointer duration-300 active:bg-black">+</button>
           </div>
         
           </div>
           <button className="border rounded-lg font-normal text-lg flex items-center justify-center px-2 hover:bg-gray-800 hover:text-white cursor-pointer duration-300 active:bg-black "
           onClick={()=>dispatch(addToCart({
            _id:detail.title,
            
            image:detail.image,
            price:detail.price,
            quantity:baseQty,
            description:detail.description,
           }) )&& toast.success(`${detail.title} is added`)}>Add to Cart</button>
           </div>
           
           <div className="text-lg mx-1 mt-2 text-gray-600">
            Category:  {detail.category}
        </div>


            </div>

      

        </div>
        <ToastContainer
     position="top-left"
     autoClose={2000}
     hideProgressBar={false}
     newestOnTop={false}
     closeOnClick
     rtl={false}
     pauseOnFocusLoss
     draggable
     pauseOnHover
     theme="dark"
    >
    </ToastContainer>
    </div>);
}
export default Product;